enum Etapas {
    CREADA = 1,
    FINALIZADA = 2,
    ANULADO = 3,
    CERRADA = 4,
    CANCELADA = 5,
    EN_ALISTAMIENTO = 6,
    ALISTADO = 7,
    // FINALIZADA = 8,
    DESPACHADO = 9,
}

export default Etapas;
